import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/hpps',
    pathMatch: 'full',
  },
  {
    path: 'hpps',
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './features/home-power-prime-solutions/landing/landing.component'
          ).then((m) => m.LandingComponent),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import(
            './features/home-power-prime-solutions/legal/privacy-policy/privacy-policy.component'
          ).then((m) => m.PrivacyPolicyComponent),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import(
            './features/home-power-prime-solutions/legal/terms-and-conditions/terms-and-conditions.component'
          ).then((m) => m.TermsAndConditionsComponent),
      },
      {
        path: 'services',
        loadComponent: () =>
          import('./shared/components/layout/layout.component').then(
            (m) => m.LayoutComponent,
          ),
        children: [
          {
            path: 'pool-cleaning',
            loadComponent: () =>
              import(
                './features/home-power-prime-solutions/services-provided/pool-cleaning/pool-cleaning.component'
              ).then((m) => m.PoolCleaningComponent),
          },
          {
            path: 'gardening',
            loadComponent: () =>
              import(
                './features/home-power-prime-solutions/services-provided/gardening/gardening.component'
              ).then((m) => m.GardeningComponent),
          },
          {
            path: 'roof-sealing',
            loadComponent: () =>
              import(
                './features/home-power-prime-solutions/services-provided/roof-sealing/roof-sealing.component'
              ).then((m) => m.RoofSealingComponent),
          },
          {
            path: 'sidewalk-cleaning',
            loadComponent: () =>
              import(
                './features/home-power-prime-solutions/services-provided/sidewalk-cleaning/sidewalk-cleaning.component'
              ).then((m) => m.SidewalkCleaningComponent),
          },
          {
            path: 'painting',
            loadComponent: () =>
              import(
                './features/home-power-prime-solutions/services-provided/painting/painting.component'
              ).then((m) => m.PaintingComponent),
          },
          {
            path: '',
            redirectTo: '/hpps/services/pool-cleaning',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },
  {
    path: 'hpower-plus',
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './features/home-power-prime-solutions-plus/landing/landing.component'
          ).then((m) => m.LandingComponent),
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import(
            './features/home-power-prime-solutions-plus/legal/privacy-policy/privacy-policy.component'
          ).then((m) => m.PrivacyPolicyComponent),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import(
            './features/home-power-prime-solutions-plus/legal/terms-and-conditions/terms-and-conditions.component'
          ).then((m) => m.TermsAndConditionsComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/hpps',
  },
];
